
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
name: "newphonenum",
components: {
XHeader, XInput,Group,CheckIcon
},
data() {
return {
phone:'',
vercode:'',
stunum:'',
isshow:false,
isright: function (value) {
return {
valid: /^1(3|4|5|7|8)\d{9}$/.test(value),
msg: '请输入正确的手机号码'
}
},
}
},
mounted(){
this.stunum = this.$store.state.stu_num;
this.phone='12132432434';
},
methods:{
valide(){
this.$router.push({name: 'verphonenum', params: {stunum: this.stunum}})
},
}
}



// WEBPACK FOOTER //
// ./src/components/ChangePass.vue